import Vue from 'vue'
import Router from 'vue-router'
import routerList from './routerList'

// 解决报错：Redirected when going from "X" to "X" via a navigation guard.
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject){
		return originalPush.call(this, location, onResolve, onReject)
	}
	return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace(location, onResolve, onReject) {
	if (onResolve || onReject){
		return originalReplace.call(this, location, onResolve, onReject)
	}
	return originalReplace.call(this, location).catch(err => err)
}

Vue.use(Router)

export const constantRouterMap = [
	// 主路由
	{
		path:'/',
		component:resolve=>require(['@/views/System/Home'], resolve),
		// 登录后跳转首页
		redirect:'/index',
		children:routerList()
	},

	{
		path:"*",
		redirect:"/404",
		hidden:true,
	},
]

export default new Router({
	// mode:'history', // require service support
	scrollBehavior:()=>({ y:0 }),
	routes:constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js